import React, { useState, useEffect } from "react";
import "../../App.css";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { getReferencesNames, getReferenceUrl } from "../../api/test";
import { Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function ReferenceListContent(props) {
  // Declarations
  const user = props.user;
  const [references, setReferences] = useState([]);
  const [searchRef, setSearchRef] = useState(
    localStorage.getItem("RefSearchTerm")
  );
  const [subject, setSubject] = useState(localStorage.getItem("RefSubject"));
  const [grade, setGrade] = useState(localStorage.getItem("RefGrade"));
  const [isLoading, setIsLoading] = useState(false);

  var idCount = 0;

  var subjects = [];
  subjects[0] = "";
  subjects[2] = "Physical Sciences";
  subjects[3] = "Mathematics";
  subjects[7] = "Maths Lit";
  subjects[10] = "Life Sciences";
  subjects[12] = "Economic Sciences";
  subjects[13] = "Life Orientation";

  var count = 0;
  // Main code
  const getReferences = async () => {
    const pdfReferences = await getReferencesNames(
      user.token,
      grade,
      subject,
      searchRef
    );

    var gradeResources = pdfReferences.message.filter((item) => {
      return item.grade === grade.toString();
    });

    var anyGradeResources = pdfReferences.message.filter(
      (item) => item.grade === "Any"
    );

    setReferences([...gradeResources, ...anyGradeResources]);

    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    getReferences();
  }, [searchRef, grade, subject]);

  const gradeHandler = async (e) => {
    setGrade(e.target.value);
    localStorage.setItem("RefGrade", e.target.value);
  };

  const searchHandler = (e) => {
    setSearchRef(e.target.value);
    localStorage.setItem("SearchTerm", e.target.value);
  };

  const subjectHandler = async (e) => {
    setSubject(e.target.value);
    localStorage.setItem("RefSubject", e.target.value.toString());
  };

  const onClickHandler = async (id) => {
    const refDetailsResponse = await getReferenceUrl(user.token, id.toString());
    const url = refDetailsResponse.message.url;
    window.open(url);
  };

  return (
    <div
      style={{
        maxWidth: "100%",
        backgroundColor: "#212a41",
        padding: "15px",
        borderRadius: "5px",
      }}
    >
      <h2
        style={{
          fontWeight: "bold",
          color: "#fbcd02",
          padding: "5px",
          textAlign: "left",
          marginBottom: "10px",
        }}
      >
        Resources
      </h2>
      <hr
        style={{
          marginBottom: "20px",
          borderColor: "#FBCD02",
          borderWidth: "1px",
          borderStyle: "solid",
          width: "100%",
        }}
      />
      <Box
        component="form"
        sx={{ "& > :not(style)": { width: "100%", marginBottom: "10px" } }}
        noValidate
        autoComplete="off"
      >
        <TextField
          id="outlined-basic"
          label="Search"
          variant="outlined"
          value={searchRef}
          onChange={searchHandler}
          fullWidth
          sx={{
            backgroundColor: "#00122d",
            borderRadius: "5px",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#00122d",
              },
              "&:hover fieldset": {
                borderColor: "#FBCD02",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#FBCD02",
              },
            },
          }}
          InputLabelProps={{ style: { color: "#FBCD02" } }}
          inputProps={{ style: { color: "white" } }}
        />

        {/* Grade Dropdown */}
        <Box sx={{ minWidth: 120, marginTop: "10px" }}>
          <FormControl fullWidth>
            <InputLabel
              id="grade-select-label"
              sx={{
                color: "#FBCD02",
                "&.Mui-focused": {
                  color: "#FBCD02",
                },
              }}
            >
              Grade
            </InputLabel>
            <Select
              labelId="grade-select-label"
              id="grade-select"
              value={grade}
              label="Grade"
              onChange={gradeHandler}
              sx={{
                backgroundColor: "#00122d",
                color: "white",
                "& .MuiSvgIcon-root": {
                  color: "white",
                },
                textAlign: "left",
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#FBCD02",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#00122d",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#FBCD02",
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    textAlign: "left",
                    backgroundColor: "#00122d",
                    color: "white",
                  },
                },
                MenuListProps: {
                  sx: {
                    "& .Mui-selected": {
                      backgroundColor: "#FBCD02 !important",
                      color: "#00122d",
                    },
                  },
                },
              }}
            >
              <MenuItem value="none" disabled>
                None
              </MenuItem>
              <MenuItem value={8}>8</MenuItem>
              <MenuItem value={9}>9</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={11}>11</MenuItem>
              <MenuItem value={12}>12</MenuItem>
              <MenuItem value={"Teacher"}>Teacher</MenuItem>
            </Select>
          </FormControl>
        </Box>
        {/* Subject Dropdown */}
        <Box sx={{ minWidth: 120, marginTop: "20px" }}>
          <FormControl fullWidth>
            <InputLabel
              id="subject-select-label"
              sx={{
                color: "#FBCD02",
                "&.Mui-focused": {
                  color: "#FBCD02",
                },
              }}
            >
              Subject
            </InputLabel>
            <Select
              labelId="subject-select-label"
              id="subject-select"
              value={subject}
              label="Subject"
              onChange={subjectHandler}
              sx={{
                backgroundColor: "#00122d",
                color: "white",
                "& .MuiSvgIcon-root": {
                  color: "white",
                },
                textAlign: "left",
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#FBCD02",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#00122d",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#FBCD02",
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    textAlign: "left",
                    backgroundColor: "#00122d",
                    color: "white",
                  },
                },
                MenuListProps: {
                  sx: {
                    "& .Mui-selected": {
                      backgroundColor: "#FBCD02 !important",
                      color: "#00122d",
                    },
                  },
                },
              }}
            >
              <MenuItem value={""}>All Subjects</MenuItem>
              <MenuItem value={2}>Physical Sciences</MenuItem>
              <MenuItem value={3}>Mathematics</MenuItem>
              <MenuItem value={7}>Maths Lit</MenuItem>
              <MenuItem value={10}>Life Sciences</MenuItem>
              <MenuItem value={12}>Economic Sciences</MenuItem>
              <MenuItem value={13}>Life Orientation</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
      <div style={{ marginTop: "20px" }}>
        {/* Loading State */}
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              backgroundColor: "#00122d",
            }}
          >
            <CircularProgress
              sx={{
                color: "#FBCD02",
                size: 60,
                thickness: 4,
              }}
            />
          </Box>
        ) : references.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              color: "white",
              "@keyframes fadeIn": {
                from: { opacity: 0 },
                to: { opacity: 1 },
              },
              animation: "fadeIn 2s ease-in-out",
            }}
          >
            <ErrorOutlineIcon
              sx={{
                fontSize: 40,
                marginBottom: 2,
                animation: "fadeIn 2s ease-in-out",
              }}
            />
            <Typography
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                animation: "fadeIn 2s ease-in-out",
              }}
            >
              No Resources Found
            </Typography>
          </Box>
        ) : (
          // filter for grade

          references.map((item, i) => {
            if (
              item.grade === "Any" &&
              i > 0 &&
              references[i - 1] &&
              references[i - 1].grade === grade.toString()
            ) {
              return (
                <div
                  key={"other-resources"}
                  className="ReferenceCard"
                  style={{
                    backgroundColor: "#FBCD02",
                    marginBottom: "20px",
                    marginTop: "20px",
                  }}
                >
                  {" ------ Other Resources ------ "}
                </div>
              );
            } else {
              return (
                <div
                  key={item.id}
                  className="ReferenceCard"
                  style={{
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderColor: "#00112e",
                    backgroundColor: "white",
                    marginBottom: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => onClickHandler(item.id)}
                >
                  {item.name}
                </div>
              );
            }
          })
        )}
        ;{/* No More Resources Message */}
        {references.length > 0 && !isLoading && (
          <div
            style={{ color: "white", textAlign: "center", fontWeight: "bold" }}
          >
            No More Resources Found
          </div>
        )}
      </div>
    </div>
  );
}
